import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconSortDirection = ({
  direction = 'down',
  ...props
}: SvgIconProps & {
  direction?: 'up' | 'down'
}) => {
  let rotateValue

  switch (direction) {
    case 'up': {
      rotateValue = 'rotate(0deg)'
      break
    }
    case 'down': {
      rotateValue = 'rotate(180deg)'
      break
    }
  }

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      sx={{ transform: rotateValue }}
    >
      <path
        d="M20 18L3 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 8L3 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 13L3 13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 9.5L17.5 7M17.5 7L20 9.5M17.5 7V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
